import clsx from 'clsx';

import type { ButtonProps } from './Button';
import ButtonPill from './ButtonPill';
import s from './ButtonPill.module.scss';

const ButtonPillPrimary = ({ className, ...props }: ButtonProps) => (
  <ButtonPill className={clsx(s.primary, className)} {...props} />
);

export default ButtonPillPrimary;
